const createInstance = (reducer, initialState) => {
  let currentState = initialState;

  const subscribers = [];

  const dispatch = (...actions) => {
    const newState = actions.reduce((previousState, action) => {
      return reducer(previousState, action);
    }, currentState);

    if (currentState !== newState) {
      currentState = newState;

      subscribers.forEach(subscriber => subscriber(currentState))
    }
  };

  const onStateChange = (subscriber, executeImmediately = true) => {
    subscribers.push(subscriber);

    if (executeImmediately) {
      subscriber(currentState);
    }

    const unsubscribe = () => subscribers.splice(subscribers.indexOf(subscriber), 1);

    return unsubscribe;
  };

  return {
    dispatch,
    onStateChange
  };
};

export default {
  createInstance
};
